export default "__VITE_ASSET__CbYDMd2$__"